import { toast } from "../components/ui/use-toast";
import { Schedule } from "../types";
import api from "./api";

export async function getScheduleById(id: string) {
  try {
    const res = await api.get<Schedule>(`/schedule/${id}`);
    if (res.status > 299) {
      throw new Error(res.statusText);
    }
    return res.data;
  } catch (error: any) {
    toast({
      title: "Error",
      description: "Unable to fetch schedule",
      variant: "destructive",
    });
    return null;
  }
}
